var TestComponent = (function () {
    function TestComponent() {
    }
    return TestComponent;
}());
export { TestComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/test/test.component.ts.pre-build-optimizer.js